import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './ProgressHeader.css';

interface ProgressHeaderProps {
  currentSection: number;
  totalSections: number;
  onSectionClick: (section: number) => void;
  sectionStates: {
    [key: number]: 'active' | 'completed' | 'upcoming';
  };
}

const ProgressHeader: React.FC<ProgressHeaderProps> = ({
  currentSection,
  totalSections,
  onSectionClick,
  sectionStates,
}) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  
  const sectionTitles = [
    'Client Information',
    'ED/PE Branch',
    'Masturbation History',
    'Medical & Lifestyle',
    'Other Information',
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="progress-header">
      <div className="header-content">
        <div className="brand">
          <img 
            src="/assets/images/rxmen-logo.png" 
            alt="RxMen" 
            className="logo"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <h1 className="header-title">DC copilot</h1>
        </div>
        <div className="header-right">
          <div className="progress-info">
            <div className="progress-text">
              Section {currentSection} of {totalSections}
            </div>
            <div className="section-indicators">
              {Array.from({ length: totalSections }, (_, i) => i + 1).map((num) => (
                <span
                  key={num}
                  className={`indicator ${sectionStates[num] || 'upcoming'}`}
                  onClick={() => onSectionClick(num)}
                  title={sectionTitles[num - 1]}
                >
                  {num}
                </span>
              ))}
            </div>
          </div>
          <button 
            onClick={handleLogout}
            className="logout-button"
            title="Logout"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default ProgressHeader;

